var _jsxFileName = "/opt/atlassian/pipelines/agent/build/src/components/connection/Caregiver/InviteCaregiver/index.tsx";
import React, { useState } from 'react';
import { Stack, Text } from '@adc/parallax-component-library';
import { IconValidationValid } from '@adc/parallax-icons';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import { CaregiverInvitationErrorCode } from 'Enums';
import { useApiError, useAuth, useCaregiver, useToast } from 'Hooks';
import { Footer, Form, Input, Main, ScrollContainer, Spinner, TitleActionBar } from 'Components/utility';
import { SHOW_MODAL } from 'Reducers/modal/types';
import i18n from 'Utilities/i18n';
import mediator from 'Utilities/mediator';
import { store } from 'Utilities/store';
const initialValues = {
  firstName: '',
  lastName: '',
  email: ''
};
const InviteCaregiver = () => {
  const [loading, setLoading] = useState(false);
  const {
    showApiErrorModal
  } = useApiError();
  const {
    showHcpError
  } = useAuth();
  const {
    showToast
  } = useToast();
  const {
    inviteCaregiver
  } = useCaregiver();
  const validationSchema = Yup.object().shape({
    firstName: Yup.string().required(i18n.t('CreateAccountPersonalInfo.content.createAccountPersonalInfoForm.formField.firstName.errors.required')),
    lastName: Yup.string().required(i18n.t('CreateAccountPersonalInfo.content.createAccountPersonalInfoForm.formField.lastName.errors.required')),
    email: Yup.string().email(i18n.t('Login.content.signInForm.formField.email.errors.emailAddressValidEmail')).required(i18n.t('CreateAccountAccountInfo.content.createAccountAccountInfoForm.formField.email.errors.emailAddressValidEmail'))
  });
  const displayMessageError = modalProps => {
    store.dispatch({
      type: SHOW_MODAL,
      modalProps: modalProps
    });
  };
  const validateNameLengthWithError = (firstName, lastName) => {
    const {
      validation
    } = store.getState().config;
    if (!validation) {
      return false;
    }
    const fields = [{
      value: firstName,
      msgKey: 'CreateAccountAccountInfo.modals.accountInfoErrors.validationRules.firstNameMaxLength',
      max: validation.api.patient.firstName.stringMaxLength
    }, {
      value: lastName,
      msgKey: 'CreateAccountAccountInfo.modals.accountInfoErrors.validationRules.lastNameMaxLength',
      max: validation.api.patient.lastName.stringMaxLength
    }];
    const errors = fields.filter(field => field.max && field.value.length > field.max).map(field => ({
      msgKey: field.msgKey,
      count: field.max
    }));
    if (errors.length) {
      store.dispatch({
        type: SHOW_MODAL,
        modalProps: {
          details: /*#__PURE__*/React.createElement(Stack, {
            gap: "$4",
            __self: this,
            __source: {
              fileName: _jsxFileName,
              lineNumber: 114,
              columnNumber: 13
            }
          }, errors?.map((error, i) => /*#__PURE__*/React.createElement(Text, {
            key: i,
            testID: error.msgKey,
            nativeID: error.msgKey,
            type: "$bodyBase.default",
            __self: this,
            __source: {
              fileName: _jsxFileName,
              lineNumber: 116,
              columnNumber: 17
            }
          }, i18n.t(error.msgKey, {
            count: error.count
          })))),
          testID: 'NameValidation'
        }
      });
      return false;
    }
    return true;
  };
  const onSubmit = async values => {
    try {
      setLoading(true);
      const isNameValid = validateNameLengthWithError(values.firstName, values.lastName);
      if (!isNameValid) {
        return;
      }
      const {
        caregiverInvitation,
        errorCode
      } = await inviteCaregiver(values.firstName, values.lastName, values.email);
      if (caregiverInvitation) {
        mediator.publish('router:navigate', {
          url: '/llu-pending-connection',
          data: {
            caregiverInvitation
          }
        });
        showToast({
          message: i18n.t('Connections.modals.invitationSentToast.body'),
          'aria-label': i18n.t('Connections.modals.invitationSentToast.body'),
          icon: /*#__PURE__*/React.createElement(IconValidationValid, {
            color: "$support.positive.default",
            __self: this,
            __source: {
              fileName: _jsxFileName,
              lineNumber: 162,
              columnNumber: 17
            }
          })
        });
        return;
      }
      switch (errorCode) {
        case CaregiverInvitationErrorCode.RESEND_NOT_ALLOWED:
          displayMessageError({
            details: i18n.t('Connections.modals.invitationAlreadySent.body'),
            testID: 'InvitationAlreadySent'
          });
          break;
        case CaregiverInvitationErrorCode.CAREGIVER_IN_DIFFERENT_COUNTRY:
          displayMessageError({
            details: i18n.t('Connections.modals.geographicRegionError.body'),
            testID: 'LocationError'
          });
          break;
        case CaregiverInvitationErrorCode.TOO_MANY_CAREGIVER_CONNECTIONS:
          displayMessageError({
            details: i18n.t('Connections.modals.maxConnectionsError.body'),
            testID: 'TooManyConnections'
          });
          break;
        case CaregiverInvitationErrorCode.RESOURCE_ALREADY_EXISTS_CODE:
          displayMessageError({
            details: i18n.t('Connections.modals.alreadyConnectedError.body'),
            testID: 'AlreadyConnected'
          });
          break;
        case CaregiverInvitationErrorCode.FORBIDDEN_ACCOUNT_ROLE_ERROR:
          showHcpError();
          break;
        default:
          showApiErrorModal();
      }
    } catch {
      showApiErrorModal();
    } finally {
      setLoading(false);
    }
  };
  const {
    handleSubmit,
    handleChange,
    handleBlur,
    isValid,
    errors,
    touched,
    values
  } = useFormik({
    initialValues,
    onSubmit,
    validationSchema,
    validateOnBlur: true
  });
  return /*#__PURE__*/React.createElement(Main, {
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 213,
      columnNumber: 5
    }
  }, /*#__PURE__*/React.createElement(TitleActionBar, {
    testID: "AddConnection",
    title: i18n.t('Connections.content.addConnectionForm.primaryText'),
    closeBtn: true,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 214,
      columnNumber: 7
    }
  }), loading && /*#__PURE__*/React.createElement(Spinner, {
    testID: "Login",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 219,
      columnNumber: 19
    }
  }), /*#__PURE__*/React.createElement(ScrollContainer, {
    marginTop: 0,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 220,
      columnNumber: 7
    }
  }, /*#__PURE__*/React.createElement(Form, {
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 221,
      columnNumber: 9
    }
  }, /*#__PURE__*/React.createElement(Text, {
    testID: "AddConnection.secondaryText",
    fontSize: "$bodyBase.default",
    fontWeight: "$bodyBase.default",
    color: "$text.100",
    marginBottom: "$2",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 222,
      columnNumber: 11
    }
  }, i18n.t('Connections.content.addConnectionForm.secondaryText')), /*#__PURE__*/React.createElement(Stack, {
    gap: "$4",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 231,
      columnNumber: 11
    }
  }, /*#__PURE__*/React.createElement(Input, {
    "aria-label": i18n.t('Connections.content.addConnectionForm.formField.firstName.label'),
    placeholder: i18n.t('Connections.content.addConnectionForm.formField.firstName.placeholder'),
    label: i18n.t('Connections.content.addConnectionForm.formField.firstName.label'),
    testID: "firstName",
    inputMode: "text",
    errorMessage: errors.firstName,
    isInvalid: errors.firstName && touched.firstName ? true : false,
    value: values.firstName,
    onChangeText: handleChange('firstName'),
    onBlur: handleBlur('firstName'),
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 232,
      columnNumber: 13
    }
  }), /*#__PURE__*/React.createElement(Input, {
    "aria-label": i18n.t('Connections.content.addConnectionForm.formField.lastName.label'),
    placeholder: i18n.t('Connections.content.addConnectionForm.formField.lastName.placeholder'),
    label: i18n.t('Connections.content.addConnectionForm.formField.lastName.label'),
    testID: "lastName",
    inputMode: "text",
    errorMessage: errors.lastName,
    isInvalid: errors.lastName && touched.lastName ? true : false,
    value: values.lastName,
    onChangeText: handleChange('lastName'),
    onBlur: handleBlur('lastName'),
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 250,
      columnNumber: 13
    }
  }), /*#__PURE__*/React.createElement(Input, {
    "aria-label": i18n.t('Connections.content.addConnectionForm.formField.email.label'),
    placeholder: i18n.t('Connections.content.addConnectionForm.formField.email.placeholder'),
    label: i18n.t('Connections.content.addConnectionForm.formField.email.label'),
    testID: "email",
    inputMode: "text",
    errorMessage: errors.email,
    isInvalid: errors.email && touched.email ? true : false,
    value: values.email,
    onChangeText: handleChange('email'),
    onBlur: handleBlur('email'),
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 268,
      columnNumber: 13
    }
  })), /*#__PURE__*/React.createElement(Text, {
    testID: "AddConnection.body",
    fontSize: "$bodySmall.default",
    fontWeight: "$bodySmall.default",
    color: "$text.60",
    marginTop: "$4",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 285,
      columnNumber: 11
    }
  }, i18n.t('Connections.content.addConnectionForm.bodyText')))), /*#__PURE__*/React.createElement(Footer, {
    buttonText: i18n.t('Connections.content.addConnectionForm.links.inviteConnection.label'),
    onButtonSubmit: handleSubmit,
    testIDButton: "AddConnection.inviteConnection-btn",
    isButtonDisabled: !values.firstName || !values.lastName || !values.email || !isValid,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 296,
      columnNumber: 7
    }
  }));
};
export default InviteCaregiver;